document.addEventListener("DOMContentLoaded", () => {
  if (typeof gsap === "undefined") return;

  if (typeof ScrollTrigger !== "undefined") {
    gsap.registerPlugin(ScrollTrigger);
  } else {
    return;
  }

  initRevealSections();
  initMergeSections();
});

/**
 * Reveal text/content sections on scroll
 * Targets sections with ids like: fryze-gsap-XXXX
 */
function initRevealSections() {
  const sections = document.querySelectorAll('[id^="fryze-gsap-"]');

  sections.forEach((section) => {
    const items = section.querySelectorAll(
      ".js-gsap-eyebrow, .js-gsap-heading, .js-gsap-text, .js-gsap-button"
    );

    if (!items.length) return;

    gsap.set(items, {
      opacity: 0,
      y: 40
    });

    const tl = gsap.timeline({ paused: true });

    tl.to(items, {
      opacity: 1,
      y: 0,
      duration: 1,
      ease: "power3.out",
      stagger: 0.12
    });

    ScrollTrigger.create({
      trigger: section,
      start: "top 65%",
      onEnter: () => tl.restart(),
      onLeaveBack: () => tl.pause(0)
    });
  });
}

/**
 * Two-image / two-SVG merge animation
 * Targets sections with ids like: fryze-merge-XXXX
 */
function initMergeSections() {
  const sections = document.querySelectorAll('[id^="fryze-merge-"]');

  sections.forEach((section) => {
    const left = section.querySelector(".js-merge-left");
    const right = section.querySelector(".js-merge-right");

    if (!left || !right) return;

    gsap.set([left, right], {
      opacity: 0
    });

    const tl = gsap.timeline({ paused: true });

    tl.fromTo(
      left,
      {
        xPercent: -140,
        opacity: 0,
        rotate: -6
      },
      {
        xPercent: 15,
        opacity: 1,
        rotate: 0,
        duration: 1.1,
        ease: "power3.out"
      },
      0
    )
      .fromTo(
        right,
        {
          xPercent: 140,
          opacity: 0,
          y: 40
        },
        {
          xPercent: -15,
          opacity: 1,
          y: 60, // 👈 stays slightly lower
          duration: 1.1,
          ease: "power3.out"
        },
        0
      )
      .to(
        [left, right],
        {
          scale: 1.03,
          duration: 0.22,
          ease: "power1.inOut",
          yoyo: true,
          repeat: 1
        },
        "-=0.12"
      );

    ScrollTrigger.create({
      trigger: section,
      start: "top 65%",
      onEnter: () => tl.restart(),
      onLeaveBack: () => tl.pause(0)
    });
  });
}